import React from "react";
import { Link } from "react-router-dom";

import JobSummary from "./JobSummary";

const JobList = ({ jobs }) => {
  return (
    <div className="job-list section">
      {jobs &&
        jobs.map(job => {
          return (
            <Link to={"/job/" + job.id} key={job.id}>
              <JobSummary job={job} key={job.id} />
            </Link>
          );
        })}
    </div>
  );
};

export default JobList;
